import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/gradient-background/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/lines-background/lines-background.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/transaction-pending-indicator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/bridge/providers/bridge.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/providers/crypto.provider.tsx");
